export default "__VITE_ASSET__B4xVT5uZ__"